module.exports = __webpack_public_path__ + "static/media/kofte2.251f792d.png";